import { deepCopy } from "@compass/core";
import { DataModelEnum, Entity } from "generated/openApi";
import ApiService from "services/apiService";

// Moves an item in a list from a starting position, to an ending position and then updates
// the display order for every item in that list
export const reorder = <T>(list: T[], startIndex, endIndex): T[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  var updatedList = deepCopy(result);

  updatedList.forEach((item, index) => (item["displayOrder"] = index + 1));

  return updatedList;
};
